import React from 'react';
import './sparks.css';

/**
 * Yellow "✨ Buy!" pill telling the child their Sparks cover something new in Addy's Shop. `corner` pins it to the
 * top-right of a `relative` parent (the desktop tab, the phone Menu button); otherwise it sits inline (the phone
 * menu list). Decorative: the tab's aria-label says the same thing.
 */
export default function ShopBuySticker({ placement = 'inline', testId }) {
  return (
    <span aria-hidden="true" data-testid={testId} className={`sparks-buy-sticker${placement === 'corner' ? ' sparks-buy-sticker--corner' : ''}`}>
      ✨ Buy!
    </span>
  );
}
